import { api } from './api'
import type { OIDCApi, OIDCApiResponse, CreateApiRequest, UpdateApiRequest } from '@/api/types/api'

export const apisApi = {
  getApis: async (next_token?: string): Promise<OIDCApiResponse> => {
    console.log('🔍 Fetching OIDC APIs', { next_token })
    const params = next_token ? { next_token: next_token } : {}
    const response = await api.get<OIDCApiResponse>('/oidc/apis', { params })
    console.log('✅ Fetched OIDC APIs:', response.data)
    return response.data
  },

  getApi: async (api_id: string): Promise<OIDCApi> => {
    console.log('🔍 Fetching OIDC API:', api_id)
    const response = await api.get<OIDCApi>(`/oidc/apis/${api_id}`)
    console.log('✅ Fetched OIDC API:', response.data)
    return response.data
  },

  createApi: async (request: CreateApiRequest): Promise<OIDCApi> => {
    console.log('📝 Creating OIDC API:', request)
    const response = await api.post<OIDCApi>('/oidc/apis', request)
    console.log('✅ Created OIDC API:', response.data)
    return response.data
  },

  updateApi: async (request: UpdateApiRequest): Promise<OIDCApi> => {
    console.log('📝 Updating OIDC API:', request)
    const response = await api.put<OIDCApi>(`/oidc/apis/${request.api_id}`, request)
    console.log('✅ Updated OIDC API:', response.data)
    return response.data
  },

  deleteApi: async (api_id: string): Promise<void> => {
    console.log('🗑️ Deleting OIDC API:', api_id)
    await api.delete(`/oidc/apis/${api_id}`)
    console.log('✅ Deleted OIDC API')
  },

  addClientToApi: async (api_id: string, client_id: string): Promise<OIDCApi> => {
    console.log(`➕ Adding client ${client_id} to API ${api_id}`)
    const response = await api.post<OIDCApi>(`/oidc/apis/${api_id}/clients/${client_id}`)
    console.log('✅ Client added to API:', response.data)
    return response.data
  },

  removeClientFromApi: async (api_id: string, client_id: string): Promise<OIDCApi> => {
    console.log(`➖ Removing client ${client_id} from API ${api_id}`)
    const response = await api.delete<OIDCApi>(`/oidc/apis/${api_id}/clients/${client_id}`)
    console.log('✅ Client removed from API:', response.data)
    return response.data
  }
}